import { ThemeConfig } from "./ThemeConfig";

export const theme: Partial<ThemeConfig> = {
  fonts: [
    {
      font: "Nunito",
      weights: ["400", "400i", "600", "700"],
    },
    {
      font: "Shantell Sans",
      weights: ["400"],
    },
  ],
  header: {
    top: {
      container: "bg-primary-500 text-white py-2",
      link: "mx-4 last:mr-0 my-1 relative inline-block text-left text-sm font-bold hover:opacity-70",
      language: {
        container:
          "absolute py-2 rounded-md text-lg right-0 mt-2 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
        item: "px-4 py-2 block",
        default:
          "cursor-pointer ui-active:bg-blue-500 ui-active:text-white ui-not-active:bg-white ui-not-active:text-black",
        selected: "text-gray-500",
      },
    },
    menu: {
      container: "bg-white text-gray-800 py-2",
      ul: "",
      li: "px-3 py-2",
      link: "block md:inline-block text-base font-bold hover:text-primary-500",
      pending: "opacity-60",
      active: "text-primary-500",
      mobile: {
        ul: "z-50 absolute left-0 top-0 min-h-screen w-full bg-white",
      },
      desktop: {
        ul: "flex -mr-2",
      },
    },
    logo: "w-52 my-2",
    home: {
      background: "min-h-[700px] md:min-h-[550px] lg:min-h-[500px]",
      container: "container mx-auto flex-grow flex flex-col justify-around",
      message: "text-white text-shadow-md flex flex-col items-start",
      title:
        "hidden text-2xl md:text-3xl lg:text-4xl mt-6 font-bold text-primary-700 text-center font-display bg-white p-2 rounded-md",
      subtitle:
        "hidden mt-2 mb-4 text-lg lg:text-xl text-center bg-alter-500 px-2 py-1 rounded-md text-white",
      showBackground: true,
    },
    page: {
      background: "min-h-[120px] bg-blue-400",
      container: "container mx-auto flex-grow flex flex-col justify-around",
      message: false,
      title:
        "mx-auto text-3xl md:text-4xl lg:text-5xl my-6 font-bold text-center font-display text-shadow-md",
      subtitle: "mx-auto my-4 text-xl lg:text-2xl text-center",
      showBackground: false,
    },
  },
  footer: {
    menu: {
      container: "border-primary-500 border-t-2 bg-primary-800 text-white py-2",
    },
    logo: "w-48 my-2",
    bottom: {
      container: "bg-dark-700 text-sm text-white py-2",
    },
  },
  button: {
    base: "border border-transparent cursor-pointer rounded-md",
    primary: [
      "bg-alter-500 hover:bg-alter-400 text-white",
      "bg-gray-400 text-white",
    ],
    secondary: [
      "bg-alter-600 hover:bg-alter-400 text-white",
      "bg-gray-400 text-white",
    ],
    outline: [
      "border-alter-400 hover:border-alter-600",
      "text-gray-400 border-gray-400",
    ],
    size: {
      xs: "text-xs px-2 py-1",
      sm: "text-sm px-3 py-1.5",
      base: "text-base px-4 py-1.5",
      lg: "text-lg px-5 py-2.5",
      xl: "text-xl px-6 py-3",
    },
  },
  searchBox: {
    container: "shadow-md drop-shadow-md",
    tabs: "flex justify-start bg-white bg-opacity-80 rounded-t-lg shadow-md px-4",
    tab: {
      any: "mr-6 pt-3 pb-1 font-semibold border-b-4",
      inactive: "text-gray-700 hover:text-primary-700 border-transparent",
      active: "text-primary-500 font-bold border-primary-500",
    },
    form: "bg-white p-4 rounded-b-md rounded-b-md",
    input: "text-base",
    internal: {
      container: "bg-cyan-100",
    },
  },
  main: {
    home: "x",
    page: "x",
  },
  results: {
    single: "border rounded-lg overflow-hidden",
    image: "",
    data: "p-4",
  },
};
